/**
 * Страница FAQ / Pages (02_GPT-MODULAR).
 */

import { useState } from "react";
import AccordionItem from "../components/AccordionItem/AccordionItem";
import AnimatedCounter from "../components/AnimatedCounter/AnimatedCounter";
import RiveAnimation from "../components/RiveAnimation/RiveAnimation";
import { FAQ_COPY, FAQ_ITEMS, MAINTENANCE_ITEMS } from "../config/faq";
import "./FaqLayout.css";
import "./FaqItems.css";
import "./FaqMaintenance.css";

function FaqPage() {
    const [openFaqId, setOpenFaqId] = useState(0);
    const [openMaintenanceId, setOpenMaintenanceId] = useState(0);

    return (
        <div className="faq-section">
            <div className="faq-wrapper">
                {/* Левая колонка - иллюстрация */}
                <div className="faq-illustration">
                    <div className="faq-animation-container">
                        <div className="faq-badge">
                            <div className="faq-badge-number">
                                <AnimatedCounter />
                            </div>
                            <div className="faq-badge-text">{FAQ_COPY.badgeText}</div>
                        </div>
                        <RiveAnimation />
                    </div>

                    {/* Maintenance Question - под анимацией */}
                    <div className="maintenance-container">
                        <h1 className="maintenance-title">{FAQ_COPY.maintenanceTitle}</h1>
                        <p className="maintenance-description">
                            {FAQ_COPY.maintenanceDescription}
                        </p>
                        <div className="maintenance-list">
                            {MAINTENANCE_ITEMS.map((item, id) => (
                                <AccordionItem
                                    key={item.question}
                                    variant="maintenance"
                                    open={openMaintenanceId === id}
                                    onToggle={() => setOpenMaintenanceId(openMaintenanceId === id ? null : id)}
                                    question={item.question}
                                    answer={item.answer}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* Правая колонка - FAQ */}
                <div className="faq-container">
                    <h2 className="faq-label">{FAQ_COPY.label}</h2>
                    <h1 className="faq-title">{FAQ_COPY.title}</h1>
                    <p className="faq-description">
                        {FAQ_COPY.description}
                    </p>
                    <div className="faq-list">
                        {FAQ_ITEMS.map((item, id) => (
                            <AccordionItem
                                key={item.question}
                                variant="faq"
                                open={openFaqId === id}
                                onToggle={() => setOpenFaqId(openFaqId === id ? null : id)}
                                question={item.question}
                                answer={item.answer}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FaqPage;
// pages/FaqPage.js
